import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { OrganizationManager } from "../organization-manager";
import { PartnerOrganization } from "../partner-organization";
import { PartnerOrganizationLeadEntityConfig } from "./config";
import { PartnerOrganizationLeadFilters } from "./filters";
import { PartnerOrganizationLeadMethods } from "./methods";

@HyperEntity("partner-organization-lead", PartnerOrganizationLeadEntityConfig)
export class PartnerOrganizationLead extends extender(
  PartnerOrganizationLeadFilters,
  PartnerOrganizationLeadMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ caption: "שם הארגון" })
  name = "";

  @Fields.string({
    dbName: "handling_manager_id",
    caption: "מנהל מלווה",
  })
  handlingManagerId = "";

  @Relations.toOne<PartnerOrganizationLead, OrganizationManager>(
    () => OrganizationManager,
    "handlingManagerId",
  )
  handlingManager?: OrganizationManager;

  @Fields.literal(() => ["CALL", "WHATSAPP", "EMAIL"] as const, {
    dbName: "contact_channel",
    caption: "דרך יצירת קשר",
  })
  contactChannel: "CALL" | "WHATSAPP" | "EMAIL" = "CALL";

  @Fields.string({
    dbName: "phone_number",
    allowNull: true,
    caption: "טלפון",
  })
  phoneNumber?: string | null;

  @Fields.string({
    allowNull: true,
    caption: "מייל",
  })
  email?: string | null;

  @Fields.string({
    dbName: "contact_role",
    allowNull: true,
    caption: "תפקיד",
  })
  contactRole?: string | null;

  @Fields.string({
    dbName: "notes",
    allowNull: true,
    caption: "הערות",
  })
  notes?: string | null;

  @Fields.string({
    dbName: "partner_organization_id",
    allowNull: true,
    caption: "ארגון שותף",
  })
  partnerOrganizationId?: string | null;

  @Relations.toOne<PartnerOrganizationLead, PartnerOrganization>(
    () => PartnerOrganization,
    "partnerOrganizationId",
  )
  partnerOrganization?: PartnerOrganization;

  @Fields.date({
    dbName: "converted_at",
    allowNull: true,
    caption: "תאריך המרה",
  })
  convertedAt?: Date | null;

  @Fields.createdAt({ dbName: "created_at", caption: "תאריך יצירה" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at", caption: "תאריך עדכון" })
  updatedAt = new Date();
}
